import { vibrations } from './Vibrations';
import { CustomEvents } from './types';
export class AppMessageController {
    handler;
    constructor() {
        this.handler = window.handleJs2;
        window.addEventListener('message', function (event) {
            if (!event.data)
                return;
            if (event.data.data === 'toggleBackgroundMode') {
                window.dispatchEvent(new CustomEvent(CustomEvents.toggleBackgroundMode));
            }
            if (event.data.data === 'sendVibrationInfo') {
                vibrations.available = event.data.canVibrate;
            }
        }, false);
    }
    sendMessage(message) {
        if (!this.handler)
            return;
        this.handler.postMessage(message);
    }
}
export const appMessageController = new AppMessageController();
//# sourceMappingURL=AppMessageController.js.map